<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <div class="flex flex-1 justify-between items-center gap-2">
    <mat-icon class="warning-icon text-yellow-500">warning</mat-icon>
    <h3 class="flex-1 m-0 font-semibold">{{ data.msg.title | translate }}</h3>
  </div>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" [mat-dialog-close]="true">
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>

<mat-dialog-content class="overflow-hidden px-6">
  <div class="flex flex-col h-full">
    <div class="mb-2">{{data.msg.content}}</div>
    <div class="mb-2">{{data.msg.preText}}</div>
    <div class="flex-1 max-h-[50vh] overflow-auto">
      <ul class="bullet-class" [innerHTML]="data.msg.listContent"></ul>
    </div>
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="secondary" variation="outline" [mat-dialog-close]="true">{{'global.cancel' | translate}}</flow-button>
</div>